import type { MarketplaceId } from "@nova-ai/shared"

/** Keep a prior query result only while the route still names the same shop. */
export function keepPreviousForMarketplace<T extends { marketplace: MarketplaceId }>(
  marketplace: MarketplaceId
): (previous: T | undefined) => T | undefined {
  return (previous) => (previous?.marketplace === marketplace ? previous : undefined)
}
